/* global axios */

const DEFAULT_API_VERSION = 'v1';

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  /* eslint-disable no-underscore-dangle -- globals portail / legacy */
  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    if (typeof window === 'undefined') return '';

    // Ne pas utiliser split('/')[3] : casse avec préfixe de chemin, locale, proxy, etc.
    const fromPath = window.location.pathname.match(/\/accounts\/(\d+)/);
    if (fromPath) {
      return fromPath[1];
    }

    if (window.__PORTAL_ACCOUNT_ID__) {
      return window.__PORTAL_ACCOUNT_ID__;
    }

    if (window.__VUE_STORE__) {
      const portalStore = window.__VUE_STORE__;
      const currentUser = portalStore.getters?.getCurrentUser;
      if (currentUser?.account_id) {
        return String(currentUser.account_id);
      }
    }

    return '';
  }
  /* eslint-enable no-underscore-dangle */

  baseUrl() {
    let url = this.apiVersion;

    if (this.options.enterprise) {
      url = `/enterprise${url}`;
    }

    if (this.options.accountScoped) {
      const accountId = this.accountIdFromRoute;
      if (accountId) {
        url = `${url}/accounts/${accountId}`;
      } else if (import.meta.env.DEV) {
        // Sans accountId les routes nested accounts ne répondent pas (liste vide / 404).
        // eslint-disable-next-line no-console
        console.warn(
          '[ApiClient] accountId introuvable dans l’URL (attendu /accounts/:id/…). Ressource:',
          this.resource
        );
      }
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default ApiClient;
